import React, {useState, useEffect} from 'react';
import {Route} from 'react-router-dom';
import {createBrowserHistory} from 'history';

import {connect} from "react-redux";
import LoginPage from "../pages/login-page";
import PolicyPage from "../pages/policy-page";
import PortfolioPage from "../pages/portfolio-page";
import {_getCountry, _getLang, _getPolicyToken, _getPortfolioToken, _checkSystemAvailable, _checkPVTStatus} from "../store/system/service";
import SecureRoute from "../utils/secure-route";
import BrokenPage from "../pages/broken-page";
import NavigationPage from "../pages/navigation-page";
import ResetPasswordPage from "../pages/reset-password-page";
import RegistrationPage from "../pages/registration-page";
import RequestTrackingPage from "../pages/request-tracking-page";
import RequestTrackingDetailPage from "../pages/request-tracking-detail-page";
import AdminLoginPage from "../pages/admin-page";

let history;

export function getHistory() {
    if (!history) {
        history = createBrowserHistory();
    }

    return history;
}

const Routes = (props) => {

    const isPolicyAuthenticated = () => {
        let status = false;
        if (props.portfolioToken) {
            // const decoded = jwt(props.policyToken);
            // const expiryDate = new Date( decoded.exp * 1000);
            // status =  expiryDate > new Date();
            status = true;
        }
        // console.log("authenticated = " + status);
        return status;
    }

    const hasPortfolioAccessToken = () => {
        let status = false;
        if (props.portfolioToken){
            status = true;
        }

        // console.log("authenticated = " + status);
        return status;
    }

    useEffect(() => {
        props.checkSystemAvailable();
        props.checkPVTStatus();
    }, []);

    return (
        <>
            <Route path='/' exact component={LoginPage} />
            <Route path='/login' exact component={LoginPage} />
            <SecureRoute path='/policy'  component={PolicyPage} auth={isPolicyAuthenticated()}/>
            <SecureRoute path='/portfolio' component={PortfolioPage} auth={hasPortfolioAccessToken()}/>
            <Route path='/pageUnavailable' exact component={BrokenPage}/>
            <Route path='/resetPassword' exact component={ResetPasswordPage}/>
            <Route path='/navigate' exact component={NavigationPage} />
            <Route path='/register' exact component={RegistrationPage} />
            <SecureRoute path='/requestTracking' exact component={RequestTrackingPage}  auth={hasPortfolioAccessToken()}/>
            <SecureRoute path='/requestTrackingDetail' exact component={RequestTrackingDetailPage}  auth={hasPortfolioAccessToken()}/>
            <Route path='/admin-login' exact component={AdminLoginPage} />
        </>
    );
}


const mapStateToProps = (state) => {
  return {
    country: _getCountry(state),
    lang: _getLang(state),
    policyToken: _getPolicyToken(state),
    portfolioToken: _getPortfolioToken(state)
  }
}

const mapDispatchToProps = {
    checkSystemAvailable: _checkSystemAvailable,
    checkPVTStatus: _checkPVTStatus
};

export default connect(mapStateToProps, mapDispatchToProps)(Routes);
